// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const List: React.FC<{ width?: number; height?: number }> = ({ width = 16, height = 13 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 13">
            <path
                fill="currentColor"
                d="M.774 0A.76.76 0 0 0 0 .75v1.5c0 .416.345.75.774.75h1.549a.76.76 0 0 0 .774-.75V.75A.76.76 0 0 0 2.323 0zM5.42.75c-.429 0-.774.334-.774.75s.345.75.774.75h9.807c.429 0 .774-.334.774-.75s-.345-.75-.774-.75zm0 5a.76.76 0 0 0-.774.75c0 .416.345.75.774.75h9.807c.429 0 .774-.334.774-.75s-.345-.75-.774-.75zm0 5c-.429 0-.774.334-.774.75s.345.75.774.75h9.807c.429 0 .774-.334.774-.75s-.345-.75-.774-.75zM0 5.75v1.5c0 .416.345.75.774.75h1.549a.76.76 0 0 0 .774-.75v-1.5A.76.76 0 0 0 2.323 5H.774A.76.76 0 0 0 0 5.75zM.774 10a.76.76 0 0 0-.774.75v1.5c0 .416.345.75.774.75h1.549a.76.76 0 0 0 .774-.75v-1.5a.76.76 0 0 0-.774-.75z"
            />
        </svg>
    );
};

export default React.memo(List);
